import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import {
  RouterModule
} from '@angular/router';

import {
  HttpErrorResponse
} from '@angular/common/http';

import {
  UserService
} from '../../../core/services/user.service';

@Component({
  selector: 'app-user-register',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule
  ],

  templateUrl:
    './user-register.component.html',

  styleUrls: [
    './user-register.component.scss'
  ]
})
export class UserRegisterComponent
  implements OnInit {

  userForm: FormGroup;

  users: any[] = [];

  editingUserId:
    string | null = null;

  activeTab:
    'LIST' | 'FORM' = 'LIST';

  loading = false;

  constructor(

    private fb: FormBuilder,

    private userService: UserService

  ) {

    this.userForm = this.fb.group({

      name: [
        '',
        Validators.required
      ],

      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],

      phone: [
        '',
        Validators.required
      ],

      cpf: [
        '',
        Validators.required
      ],

      password: [
        '',
        Validators.required
      ],

      confirmPassword: [
        '',
        Validators.required
      ],

      role: [
        '',
        Validators.required
      ],

      terms: [
        false,
        Validators.requiredTrue
      ]

    });

  }

  ngOnInit(): void {

    this.loadUsers();

  }

  loadUsers(): void {

    this.userService
      .findAll()
      .subscribe({

        next: (response: any[]) => {

          this.users = response;

        },

        error: (
          error: HttpErrorResponse
        ) => {

          console.error(
            'Erro ao carregar usuários',
            error
          );

        }

      });

  }

  onSubmit(): void {

    if (
      this.userForm.invalid
    ) {

      return;

    }

    const user =
      this.userForm.value;

    if (

      user.password !==
      user.confirmPassword

    ) {

      alert(
        'As senhas não coincidem'
      );

      return;

    }

    this.loading = true;

    if (
      this.editingUserId
    ) {

      this.userService

        .updateUser(

          this.editingUserId,

          user

        )

        .subscribe({

          next: () => {

            this.afterSave();

          },

          error: (
            error: HttpErrorResponse
          ) => {

            console.error(error);

            this.loading = false;

          }

        });

      return;

    }

    this.userService
      .createUser(user)
      .subscribe({

        next: () => {

          this.afterSave();

        },

        error: (
          error: HttpErrorResponse
        ) => {

          console.error(error);

          this.loading = false;

        }

      });

  }

  editUser(
    user: any
  ): void {

    this.editingUserId =
      user.id;

    this.userForm.patchValue({

      name: user.name,

      email: user.email,

      phone: user.phone,

      cpf: user.cpf,

      role: user.role,

      password: '',

      confirmPassword: '',

      terms: true

    });

    this.activeTab =
      'FORM';

  }

  deleteUser(
    id: string
  ): void {

    const confirmed =
      confirm(
        'Deseja realmente excluir o usuário?'
      );

    if (!confirmed) {

      return;

    }

    this.userService
      .deleteUser(id)
      .subscribe({

        next: () => {

          this.loadUsers();

        },

        error: (
          error: HttpErrorResponse
        ) => {

          console.error(error);

        }

      });

  }

  newUser(): void {

    this.editingUserId =
      null;

    this.userForm.reset();

    this.userForm.patchValue({

      terms: false

    });

    this.activeTab =
      'FORM';

  }

  cancel(): void {

    this.editingUserId =
      null;

    this.userForm.reset();

    this.userForm.patchValue({

      terms: false

    });

    this.activeTab =
      'LIST';

  }

  afterSave(): void {

    this.loading = false;

    this.editingUserId =
      null;

    this.userForm.reset();

    this.userForm.patchValue({

      terms: false

    });

    this.loadUsers();

    this.activeTab =
      'LIST';

  }

}